import { UseMutationResult, useMutation } from "@tanstack/react-query";
import { Methods } from "../../constants/CommonConstants";
import Api from "../axios";
import { EndPoints } from "../endPoints";
import { GeneralResponse, Token } from "../../../types/api";
import { handleApiResponseErrors } from "../HandleAPIResponseErrors";
import { ICreateFacilityRequest } from "../../../types/apis/auth-apis";

export const createFacility = async ({
  payload,
  token,
}: {
  payload: FormData;
  token: Token;
}): Promise<GeneralResponse> => {
  try {
    const response = await Api<any, GeneralResponse<ICreateFacilityRequest>>({
      method: Methods.POST,
      endpoint: EndPoints.createFacility,
      body: payload,
      headers: {
        "Content-Type": "multipart/form-data",
      },
      token,
    });
    handleApiResponseErrors(response, "validation_error");
    return response;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};

export const useCreateFacility = (options = {}) => {
  const mutation: UseMutationResult<
    GeneralResponse,
    Error,
    { payload: FormData; token: Token }
  > = useMutation({
    mutationKey: ["create_facility"],
    mutationFn: createFacility,
    ...options,
  });

  return {
    data: mutation.data,
    error: mutation.error,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    mutate: mutation.mutate,
    reset: mutation.reset,
    status: mutation.status,
  };
};
